
import { Component, OnInit, Inject, Injectable, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmAddNewVendorComponent } from 'src/app/Product/confirm-add-new-vendor/confirm-add-new-vendor.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from 'src/app/_services/login.service';
import { AuthService } from 'src/app/_services/auth.service';
import { VendortakenComponent } from '../vendortaken/vendortaken.component';
import { VendorService } from 'src/app/_services/vendor.service';

@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-add-new-vendor',
  templateUrl: './add-new-vendor.component.html',
  styleUrls: ['./add-new-vendor.component.css']
})

export class AddNewVendorComponent implements OnInit {

  constructor(public dialog: MatDialog,
    public dialogRef: MatDialogRef<AddNewVendorComponent>,
    private loginService: LoginService,
    private authService: AuthService,
    private vendorService: VendorService) { }

  submitted: boolean = true;
  custId = this.authService.getRegistredUserDetails().customerId;
  token = this.authService.getToken();

  ngOnInit(): void {
    //this.allCompanyDetails()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  vendorDetails: FormGroup = new FormGroup(
    {
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      phone: new FormControl('', [
        Validators.required,
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')]),
      addr1: new FormControl('', [Validators.required]),
      vendorId: new FormControl('', [Validators.required,
      Validators.minLength(2)]),
      companyName: new FormControl(''),
      companyContact: new FormControl(''),
      addr2: new FormControl(''),
      city: new FormControl(''),
      state: new FormControl(''),
      zip: new FormControl(''),
      customerId: new FormControl(this.custId),
      paymentElection : new FormControl('ACH')
    })

  openDialog(): void {
    const dialogRef = this.dialog.open(ConfirmAddNewVendorComponent, {
      width: '500px',
      disableClose: true,
      data: {
        vendorId: this.vendorDetails.value.vendorId,
        email: this.vendorDetails.value.email,
        phone: this.vendorDetails.value.phone,
        addr1: this.vendorDetails.value.addr1,
        addr2: this.vendorDetails.value.addr2,
        city: this.vendorDetails.value.city,
        state: this.vendorDetails.value.state,
        zip: this.vendorDetails.value.zip,
        companyName: this.vendorDetails.value.vendorId,
        companyContact: this.vendorDetails.value.phone,
        customerId: this.vendorDetails.value.customerId,
        paymentElection : this.vendorDetails.value.paymentElection
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  onSubmit() {
    this.submitted = true;
    this.vendorService.Allvendors(this.token, this.custId).subscribe((response) => {
      const user = response.find((x) => x.vendorId === this.vendorDetails.value.vendorId)
      if (user) {
        const dialogRef = this.dialog.open(VendortakenComponent, {
          width: '500px',
          disableClose: true
        });
      }
      else {
        this.openDialog();
      }
    })

    if (this.vendorDetails.valid) {
      console.log(this.vendorDetails.value);
    }
  }

  get forms() {
    return this.vendorDetails.controls;
  }

  onPress(event) {
    const inputValue = event.target.value;
    const maxDigits = 11;
    if (event.target.value.length > 11) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.vendorDetails.value.phone = event.target.value
    }
  }
}
